module.exports = __webpack_public_path__ + "static/media/SummaryCh7_A01378565.ebb7c04d.pdf";